import $ from 'jquery';
window.addEventListener('px-ready',function(){
    $('.px-video').each(function(){
        var video = $(this).attr("data-loaded-video");
        if(!$(this).find('.px-malleable-image img').attr('src')){
            if(video.includes('youtube') || video.includes('yt')){
                console.log('youtube no thumb')
                var videoId = yt_get_id(video)
                $(this).find('.px-malleable-image img').attr('src','//img.youtube.com/vi/'+videoId+'/maxresdefault.jpg')
            }
        }
    })
    $('.px-video').click(function(){
        var video = $(this).attr("data-loaded-video");
        if(video){
            console.log(video);
            if(video.includes('youtube') || video.includes('yt')){
                var videoId = yt_get_id(video)
                $(this).addClass('is-video-loaded');
                $(this).html('<iframe src="//www.youtube.com/embed/' + videoId + '?autoplay=1" px-size-ratio="16:9" allow="autoplay; fullscreen" frameborder="0" allowfullscreen></iframe>');
            }else if(video.includes('vimeo')){
                var videoId = vimeo_get_id(video)
                $(this).addClass('is-video-loaded');
                $(this).html('<iframe src="//player.vimeo.com/video/'+videoId+'?api=1&player_id=1&api=1&player_id=2&autoplay=1" px-size-ratio="16:9" allow="autoplay; fullscreen" frameborder="0" allowfullscreen></iframe>');
            }
            $(window).trigger('resize');
            return false;
        }
    })
})

function yt_get_id(url){
    var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
    var match = url.match(regExp);

    if (match && match[2].length == 11) {
        return match[2];
    } else {
        return 'error';
    }
}

function vimeo_get_id(url){
    //var url = "http://www.vimeo.com/7058755";
    var regExp = /https?:\/\/(?:www\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|)(\d+)(?:$|\/|\?)/;

    var match = url.match(regExp);

    if (match){
        return match[3];
    }
    else{
        alert("not a vimeo url");
    }
}